import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { Overrides, Signer } from 'ethers';
import { Contract, ContractFactory, utils } from 'ethers';

import type { StarsStaking, StarsStakingInterface } from '../StarsStaking';

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract IERC20',
        name: '_mogul',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_owner',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'depositId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
    ],
    name: 'Deposited',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'depositId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Harvest',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalAmount',
        type: 'uint256',
      },
    ],
    name: 'HarvestAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'prizePool',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'mogulPerSecond',
        type: 'uint256',
      },
    ],
    name: 'LogAddPrizePool',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [],
    name: 'LogInit',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'contract IERC20',
        name: 'lpToken',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'startTime',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'endTime',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'minLockupTime',
        type: 'uint256',
      },
    ],
    name: 'LogPoolAddition',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'endTime',
        type: 'uint256',
      },
    ],
    name: 'LogSetPoolEndTime',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'lastRewardTime',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'accMogulPerShare',
        type: 'uint256',
      },
    ],
    name: 'LogUpdatePool',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'depositId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
    ],
    name: 'Withdraw',
    type: 'event',
  },
  {
    inputs: [],
    name: 'MOGUL',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract IERC20',
        name: '_lpToken',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_minLockupTime',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_prizePool',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_startTime',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_endTime',
        type: 'uint256',
      },
    ],
    name: 'addPool',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pid',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_prizePool',
        type: 'uint256',
      },
    ],
    name: 'addPrizePool',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'depositLength',
    outputs: [
      {
        internalType: 'uint256',
        name: 'count',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'deposits',
    outputs: [
      {
        internalType: 'uint256',
        name: 'depositTimestamp',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'int256',
        name: 'rewardDebt',
        type: 'int256',
      },
      {
        internalType: 'uint256',
        name: 'withdrawTimestamp',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'depositId',
        type: 'uint256',
      },
    ],
    name: 'getDeposit',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'depositTimestamp',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
          {
            internalType: 'int256',
            name: 'rewardDebt',
            type: 'int256',
          },
          {
            internalType: 'uint256',
            name: 'withdrawTimestamp',
            type: 'uint256',
          },
        ],
        internalType: 'struct MogulStaking.Deposit',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'depositId',
        type: 'uint256',
      },
    ],
    name: 'harvest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'depositId',
        type: 'uint256',
      },
    ],
    name: 'lockupRemaining',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'lpToken',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256[]',
        name: 'pids',
        type: 'uint256[]',
      },
    ],
    name: 'massUpdatePools',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pid',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_user',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'depositId',
        type: 'uint256',
      },
    ],
    name: 'pendingMogul',
    outputs: [
      {
        internalType: 'uint256',
        name: 'pending',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'poolInfo',
    outputs: [
      {
        internalType: 'uint256',
        name: 'accMogulPerShare',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'lastRewardTime',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'prizePool',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minLockupTime',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'startTime',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'endTime',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'mogulPerSecond',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'totalDepositedLP',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'poolLength',
    outputs: [
      {
        internalType: 'uint256',
        name: 'pools',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_pid',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_endTime',
        type: 'uint256',
      },
    ],
    name: 'setPoolEndTime',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract IERC20',
        name: 'erc20',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'sweepERC20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
    ],
    name: 'updatePool',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'accMogulPerShare',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lastRewardTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'prizePool',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'minLockupTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'startTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'endTime',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'mogulPerSecond',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalDepositedLP',
            type: 'uint256',
          },
        ],
        internalType: 'struct MogulStaking.PoolInfo',
        name: 'pool',
        type: 'tuple',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'depositId',
        type: 'uint256',
      },
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pid',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'depositId',
        type: 'uint256',
      },
    ],
    name: 'withdrawAndHarvest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

type StarsStakingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StarsStakingConstructorParams,
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class StarsStakingFactory extends ContractFactory {
  constructor(...args: StarsStakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _stars: string,
    _rewarder: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<StarsStaking> {
    return super.deploy(
      _stars,
      _rewarder,
      overrides || {},
    ) as Promise<StarsStaking>;
  }
  getDeployTransaction(
    _stars: string,
    _rewarder: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_stars, _rewarder, overrides || {});
  }
  attach(address: string): StarsStaking {
    return super.attach(address) as StarsStaking;
  }
  connect(signer: Signer): StarsStakingFactory {
    return super.connect(signer) as StarsStakingFactory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StarsStakingInterface {
    return new utils.Interface(_abi) as StarsStakingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider,
  ): StarsStaking {
    return new Contract(address, _abi, signerOrProvider) as StarsStaking;
  }
}
